import { imageUploaderConstants } from "../constants/imageUploader.constants";

export const imageUploaderActions = {
  setImage,
  removeImage,
  clearImageUploader
};

function setImage(image) {
  return (dispatch) =>
    dispatch({
      type: imageUploaderConstants.IMAGEUPLOAD_SET_IMAGE, payload: {
        image,
      }
    });
};

function removeImage() {
  return (dispatch) => dispatch({ type: imageUploaderConstants.IMAGEUPLOAD_REMOVE_IMAGE });
};

function clearImageUploader() {
  return (dispatch) => {
      dispatch({ type: imageUploaderConstants.IMAGEUPLOAD_CLEAR });
  };
};
